<template>
  <div class="container log_or_reg_main">      
    <Welcome
      :text_colour="state.invitation?.campaign?.text_colour"
      :elem_colour="state.invitation?.campaign?.elem_colour" 
      :public_name="state.invitation?.campaign?.public_name"
    />
    <div class="card">
      <transition mode="out-in" name="fade">
        <UserForm v-if="!state.showCodeValidation" @next="submitForm" />
        <div v-else class="code-wrapper">
          <img src="@/assets/images/illustration/code-lock.svg" alt="Code" />
          <div class="block">
            <h2>Confirmez votre e-mail</h2>
            <p>
              Pour continuer, veuillez renseigner le code que vous avez reçu par
              e-mail à l’adresse
              <span
                class="primary-color semibold"
                v-text="joinInformations.email"
              />
            </p>
          </div>
          <CodeConfirmation
            :isLoading="state.formIsLoading"
            @validation="confirmCode"
            @back="(state.showCodeValidation = false), (state.error = null)"
          />
        </div>
      </transition>
      <div
        v-if="state.error"
        class="form-error red-color small"
        v-text="getError(state.error)"
      />
    </div>
  </div>
</template>

<script setup>
import { useToast } from "vue-toastification";
import { reactive, computed } from "vue";
import { useRouter } from "vue-router";
import { getError } from "@/composables/error.js";
import { useCandidateStore } from "@/stores/candidate.js";
import { storeToRefs } from "pinia";
import UserForm from "./UserForm.vue";
import { getImage } from "@/composables/getImage.js";
import Welcome from "../InviteWelcome.vue";

const emits = defineEmits(["setBackground"]);

const router = useRouter();

const candidateStore = useCandidateStore();

const { joinInformations } = storeToRefs(candidateStore);

const toast = useToast();

const state = reactive({
  formIsLoading: false,
  showCodeValidation: false,
  invitation: null,
  error: null,
});

state.invitation = candidateStore.invitation;

const invitationIsPublic = computed(() => {
  return !candidateStore.invitation.email;
});

if(candidateStore.invitation.campaign.bg_image_id) {
  const imageBGUrl = getImage(candidateStore.invitation.campaign.bg_image_id);
  emits("setBackground", imageBGUrl);
}

async function submitForm() {
  if (invitationIsPublic.value) {
    const verification_id = await candidateStore.getEmailVerificationToken(
      joinInformations.value.email
    );
    if (verification_id.code) {
      // There is an error
      toast.error(getError(verification_id.key), { timeout: 10000 });
    } else {
      joinInformations.value.verification_id = verification_id;

      state.showCodeValidation = true;
    }
  } else {
    registerCandidate();
  }
}

async function confirmCode(code) {
  state.formIsLoading = true;

  const resp = await candidateStore.emailVerification(
    joinInformations.value.email,
    joinInformations.value.verification_id,
    code
  );

  if (resp.verification_id) {
    registerCandidate();
  } else {
    toast.error(
      "Code de confirmation incorrect, veuillez vérifier le code renseigné."
    );
  }

  setTimeout(() => {
    state.formIsLoading = false;
  }, 600);
}

async function registerCandidate() {
  const resp = await candidateStore.createCandidate();

  if (resp.code) {
    state.error = resp.key;
  } else {
    router.push({ name: "game-home" });
  }
}
</script>
